<template>
  <CContainer :class="{ 'update-limit-location-maxcap': isDashboardView }">
    <CRow class="justify-content-center">
      <CCol md="12" class="text-start">
        <CAlert
          v-if="reqResponse.message"
          class="mt-4"
          :color="reqResponse.type"
          :show="!!reqResponse.message"
        >
          {{ reqResponse.message }}
        </CAlert>
        <div class="mb-2" :class="{ 'row px-3': isInView }">
          <div :class="{ 'col-md-6 ps-3 ps-md-0': isInView }">
            <div v-if="activeRoom && activeRoom.room" class="form-group">
              <input
                type="text"
                readonly
                class="form-control"
                placeholder="Limit"
                :value="activeRoom.room.name"
              />
            </div>
            <div v-else>
              <LazyLoadSelect
                ref="RoomsLazyLoadSelect"
                :classes="[
                  {
                    'is-invalid':
                      v$.form.room.$error || reqResponse.errors['room_id']
                  },
                  'mb-3'
                ]"
                :is-multiple="true"
                :selected="form.room"
                :selectable="(option) => !option.capacity"
                type="locations"
                placeholder="Select Location"
                @changed="
                  (value) => {
                    form.room = value
                  }
                "
              >
                <template #footer>
                  <div
                    v-if="v$.form.$error && v$.form.room.required.$invalid"
                    class="invalid-feedback"
                  >
                    This field is required
                  </div>
                  <div
                    v-if="reqResponse.errors['room_id']"
                    class="invalid-feedback"
                  >
                    {{ reqResponse.errors["room_id"][0] }}
                  </div>
                </template>
              </LazyLoadSelect>
            </div>
          </div>
          <div :class="{ 'col-md-6 pe-3 pe-md-0': isInView }">
            <div class="form-group mb-2">
              <div class="cs-placeholder-field">
                <input
                  v-model="form.limit"
                  type="text"
                  class="form-control mb-0"
                  :class="{
                    'is-invalid':
                      v$.form.limit.$error || reqResponse.errors['limit']
                  }"
                  placeholder="Limit"
                  @keypress="validateLimitInput"
                  @keyup.enter.prevent="submit()"
                />
              </div>
              <div
                v-if="v$.form.$error && v$.form.limit.required.$invalid"
                class="invalid-feedback d-block"
              >
                The limit must a number or a "-" dash (where a "-" means
                unlimited).
              </div>
              <div
                v-if="reqResponse.errors['limit']"
                class="invalid-feedback d-block"
              >
                {{ reqResponse.errors["limit"][0] }}
              </div>
            </div>
            <p class="mt-0">A "-" dash indicates unlimited</p>
          </div>
        </div>
        <div class="form-group form-actions mt-4 text-center">
          <div class="d-flex align-items-center justify-content-center">
            <div v-if="activeRoom" class="d-flex">
              <div @click="submit(true)">
                <CLoadingButton
                  :spinner="isLoading"
                  :disabled="isLoading"
                  :loading="isLoading"
                  class="me-2 px-5 py-3 btn bg-gradient-blue text-white"
                >
                  Update
                </CLoadingButton>
              </div>
              <div v-show="!isDashboardView" class="ms-2" @click="cancelEdit()">
                <CButton class="me-2 btn-gradient-border">
                  <span class="btn px-4"
                    ><b class="text-graident-blue">Cancel</b></span
                  >
                </CButton>
              </div>
            </div>
            <div v-else class="d-flex" @click="submit()">
              <CLoadingButton
                :spinner="isLoading"
                :disabled="isLoading"
                :loading="isLoading"
                class="me-2 btn px-5 py-3 bg-gradient-blue text-white"
              >
                Submit
              </CLoadingButton>
            </div>
            <router-link
              v-if="!isInView && !activeRoom"
              class="text-graident-blue ms-3"
              to="/limits/limit-location-max-cap"
            >
              <div class="d-flex align-items-center" @click="goToFullMenu()">
                <img
                  width="18"
                  class="m-0 me-2"
                  src="@/assets/images/icons/gradient-link.png"
                />
                <span class="text-graident-blue">Go to full menu</span>
              </div>
            </router-link>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import useVuelidate from "@vuelidate/core"
import { required } from "vuelidate/lib/validators"
import LazyLoadSelect from "@/components/LazyLoadSelect.vue"

export default {
  name: "CreateLimitLocationMaxCapForm",
  components: { LazyLoadSelect },
  props: ["rooms", "isInView", "activeRoom", "isDashboardView"],
  emits: ["updatedLimitLocationMaxCap", "closeModal"],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      isLoading: false,
      form: {
        room: null,
        limit: "-"
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  validations: {
    form: {
      room: {
        required
      },
      limit: {
        required
      }
    }
  },
  computed: {
    isValid() {
      return !this.v$.form.$invalid
    }
  },
  watch: {
    activeRoom: function (pass) {
      this.resetForm()
      this.resetResponseMessages()
      this.setFormByPassRecord(pass)
    }
  },
  created() {
    if (this.activeRoom) {
      this.setFormByPassRecord(this.activeRoom)
    }
  },
  unmounted() {
    this.cancelEdit()
  },
  methods: {
    submit(isUpdate = false) {
      this.resetResponseMessages()
      if (this.isValid) {
        const locationLimit = {
          room_ids:
            this.form.room && this.form.room.length
              ? this.form.room.map((room) => room.value.id)
              : this.form.room && this.form.room.value
              ? [this.form.room.value.id]
              : null,
          limit: this.form.limit === "-" ? null : parseInt(this.form.limit)
        }
        this.isLoading = true
        if (isUpdate && this.activeRoom.id) {
          this.updateRoomLimit(locationLimit)
        } else {
          this.createRoomLimit(locationLimit)
        }
      } else {
        this.v$.$touch()
      }
    },
    setFormByPassRecord(limit) {
      if (limit) {
        this.form = {
          limit: limit.limit != null ? limit.limit : "-",
          room: {
            value: {
              id: limit.room.id,
              type: "App\\Models\\Room"
            },
            label: limit.room.name
          }
        }
      }
    },
    createRoomLimit(locationLimit) {
      this.$store
        .dispatch("rooms/createRoomCapacityLimit", locationLimit)
        .then((response) => {
          const data = response.data.data
          if (!this.activeRoom) {
            this.resetForm()
          }
          if (data) {
            if (this.isDashboardView) {
              setTimeout(() => {
                this.$emit("updatedLimitLocationMaxCap")
              }, 1000)
            }
            setTimeout(() => {
              this.$emit("updatedLimitLocationMaxCap")
              this.refreshRoomsSelect()
            }, 800)
          }
          this.setSuccessResponse("Successfully created.")
          this.isLoading = false
          setTimeout(() => {
            this.resetResponseMessages()
          }, 1000)
        })
        .catch((err) => {
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
        })
    },
    updateRoomLimit(locationLimit) {
      const data = {
        limit: locationLimit.limit,
        id: this.activeRoom.id
      }
      this.$store
        .dispatch("rooms/updateRoomCapacityLimit", data)
        .then((response) => {
          this.setSuccessResponse("Successfully updated.")
          const newData = response.data.data
          if (newData) {
            this.$store.commit("rooms/UPDATE_ROOM_CAPACITY_LIMIT", newData)
          }
          this.isLoading = false
          setTimeout(() => {
            if (this.isDashboardView) {
              this.resetResponseMessages()
              this.$emit("updatedLimitLocationMaxCap")
            } else {
              this.cancelEdit()
            }
          }, 1000)
        })
        .catch((err) => {
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
        })
    },
    resetForm() {
      this.v$.$reset()
      this.form = {
        room: null,
        limit: null
      }
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    },
    cancelEdit() {
      this.$store.commit("rooms/SET_EDITABLE_ROOM_CAP_LIMIT", null)
      this.resetForm()
      this.resetResponseMessages()
    },
    refreshForm() {
      this.resetForm()
      this.resetResponseMessages()
    },
    goToFullMenu() {
      this.$emit("closeModal")
    },
    refreshRoomsSelect() {
      if (this.$refs.RoomsLazyLoadSelect) {
        this.$refs.RoomsLazyLoadSelect.refreshSelect()
      }
    },
    validateLimitInput(event) {
      if (event.keyCode >= 48 && event.keyCode <= 59) {
        if (this.form.limit === "-") {
          this.form.limit = ""
        }
        return true
      } else if (event.keyCode == 45) {
        this.form.limit = ""
        return true
      } else {
        return event.preventDefault()
      }
    }
  }
}
</script>
